import React from "react";
import { SkillLevel } from "./SkillLevel.js";
import { levelDescriptions } from "./data/level-descriptions.js";

export function Instructions() {
  return (
    <section>
      <p className="content-area">
        Detta verktyg gör det möjligt för yrkesvägledare, team,
        tvärvetenskapliga nätverk och organisationer att bedöma sin
        vägledningskompetens i förhållande till
        <span className="italics">
          {" "}
          Kompetensbeskrivning för professionella inom vägledning och
          handledning.{" "}
        </span>
        Du hittar en detaljerad kompetensbeskrivning för varje
        kompetensutlåtande genom att klicka på &#9432; knappen. Informationen i
        utvärderingsformuläret kommer inte att lagras.
      </p>
      <h3 className="bold">Instruktioner</h3>
      <div className="content-area">
        <span className="bold">Första omgången: din nuvarande kompetens</span>{" "}
        <p>
          För att utvärdera din nuvarande kompetens, vänligen fyll i formuläret
          nedan. Bekanta dig med utlåtandena på bedömningsblanketten och välj
          dennivå (0-3) som bäst beskriver ditt kunnande vid
          bedömningstidpunkten. Kompetensnivåerna beskrivs i rutan nedan. När du
          har svarat på alla kompetensutlåtanden får du en visuell
          kompetensprofil.
        </p>
      </div>
      <div className="content-area">
        <span className="bold">Andra omgången: att sätta upp kompetensmål</span>
        <p>
          Du har möjlighet att gå tillbaka till kompetensbeskrivningarna och
          definiera dina kompetensmål för varje kompetensområde. De
          kompetensnivåer som du tidigare valt för varje kompetensområde kommer
          att synas under varje påstående. När du är klar får du en visuell
          kompetensprofil som illustrerar både din nuvarande kompetens och de
          uppsatta kompetensmålen.
        </p>
      </div>
      <div className="box info-box">
        <div className="content-area">
          <h3>Kompetensnivåer</h3>
          {Object.values(levelDescriptions).map((description) => (
            <SkillLevel key={description.header} level={description} />
          ))}
          <p className="italics">
          Genom att flytta muspekaren över kompetensnivåvärdet visar verktyget motsvarande beskrivning.
          </p>
        </div>
      </div>
    </section>
  );
}
